import { render, staticRenderFns } from "./HotTopic.vue?vue&type=template&id=26044c07&scoped=true&"
import script from "./HotTopic.vue?vue&type=script&lang=js&"
export * from "./HotTopic.vue?vue&type=script&lang=js&"
import style0 from "./HotTopic.vue?vue&type=style&index=0&id=26044c07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26044c07",
  null
  
)

export default component.exports